import { render, staticRenderFns } from "./DocumentDeleteModal.vue?vue&type=template&id=6de4bd5a"
import script from "./DocumentDeleteModal.vue?vue&type=script&lang=js"
export * from "./DocumentDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports